import { toast } from "@/lib/toast";

/** iter381 pt 12b — numéro au format international (+213…). */
export const intlPhone = (raw) => { const d = String(raw || "").replace(/[^\d+]/g, ""); if (!d) return ""; if (d.startsWith("+")) return d; if (d.startsWith("00")) return `+${d.slice(2)}`; if (d.startsWith("0")) return `+213${d.slice(1)}`; return `+${d}`; };
/** Message → WhatsApp Desktop directement sur la conversation. */
export const whatsappHref = (raw) => { const p = intlPhone(raw); return p ? `whatsapp://send?phone=${p.replace("+", "")}` : undefined; };
/** Appel → WhatsApp Desktop n'expose pas de lien d'appel : on ouvre la conversation (écart signalé). */
export const whatsappCallHref = whatsappHref;
/** E-mail → fenêtre Zoho « ledesk_zoho_mail » (celle de la tuile E-mail) ; Zoho n'accepte pas de destinataire prérempli → adresse copiée. */
export const openZohoMail = async (email) => {
  if (!email) return;
  try { await navigator.clipboard.writeText(email); toast.success(`Adresse copiée : ${email}`); } catch { toast.message(email); }
  window.open("https://mail.zoho.com/zm/#mail/compose", "ledesk_zoho_mail");
};
